import { ReactNode } from 'react';
import { Panel, PanelGroup } from 'react-resizable-panels';
import FixedElementOnScroll from '../fixedElementOnScroll';
import ResizeHandle from '../resizeHandle';

type SplitViewPropsType = {
    left: ReactNode;
    right: ReactNode;
    // Minimum size of each pane, as a percentage of the group. Defaults to 20.
    minSize?: number;
    containerRef?: React.RefObject<HTMLElement | null>;
    // Distance from the top of the scroll viewport at which the right pane pins. Defaults to 0
    // (viewport top), which suits a fullscreen modal; a full page passes the app header height.
    topOffset?: number;
    /**
     * Gives the left pane `overflow: visible` (plus `min-width: 0`) instead of the library's
     * `overflow: hidden`, so a `position: sticky` descendant (e.g. a table's floating horizontal
     * scrollbar) pins to the window rather than being trapped by the pane. The library uses
     * `overflow: hidden` to make each pane a scroll container so it can shrink when dragged; the
     * explicit `min-width: 0` preserves that shrink without the scroll-container status. Defaults to
     * `false` (the review keeps the library defaults).
     */
    leftPaneOverflowVisible?: boolean;
};

function SplitView({
    left,
    right,
    minSize = 20,
    containerRef,
    topOffset = 0,
    leftPaneOverflowVisible = false,
}: SplitViewPropsType) {
    return (
        <PanelGroup
            direction="horizontal"
            className="split-view"
            style={leftPaneOverflowVisible ? { overflow: 'visible' } : undefined}
        >
            <Panel
                minSize={minSize}
                className="split-view__pane"
                style={leftPaneOverflowVisible ? { overflow: 'visible', minWidth: 0 } : undefined}
            >
                {left}
            </Panel>
            <ResizeHandle />
            <Panel minSize={minSize} className="split-view__pane">
                <FixedElementOnScroll scrollContainerRef={containerRef} topOffset={topOffset}>
                    <div className="split-view__fixed-pane">{right}</div>
                </FixedElementOnScroll>
            </Panel>
        </PanelGroup>
    );
}

export default SplitView;
